<script lang="ts" setup>
interface CardProps {
  data?: any
  online?: boolean
}

const props = withDefaults(defineProps<CardProps>(), { online: false })

const classes = getCollectionClass(props.data.collectionName)
const routeName = getPublicRoute(props.data.collectionName, props.data)
</script>

<template>
  <div
    :id="data.id"
    class="rounded-2xl relative flex flex-wrap overflow-clip h-full"
    :class="[data.collectionName]"
  >
    <div
      class="w-full flex flex-wrap lg:flex-col  py-4 relative z-10 lg:w-[30%]"
      :class="[classes?.textOnBackground]"
    >
      <NuxtLink
        v-motion
        :to="routeName"
        class="rounded-full w-[30%] ml-[2%] lg:w-[84%] lg:ml-[15%] lg:h-auto overflow-hidden z-[2] aspect-square"
        :visible="{ opacity: 1, scale: 1 }"
        :initial="{ opacity: 0, scale: 0.4 }"
        :delay="150"
      >
        <slot name="image" />
      </NuxtLink>
      <section class="px-4 pt-6 pb-2 leading-tight text-sm 2xl:mt-auto lg:mt-auto flex-1 z-[2]">
        <slot
          name="underimage"
          :route-name="routeName"
        />
      </section>
      <div class="absolute rounded-full z-[1] side h-[600%] top-[-510%] left-[-70%] w-auto lg:h-[300%] lg:right-0 lg:left-auto lg:top-[-80%] aspect-square" />

      <Icon
        v-motion
        :visible="{ opacity: 1, rotate: 0, y: 0, x: 0, scale: 1 }"
        :initial="{ opacity: 0, rotate: 50, y: 20, x: 20, scale: 0.2 }"
        :delay="350"
        name="gbf:arrow-swish-left"
        class="absolute w-16 h-16 top-3 right-[-10%] z-[2] text-lightblue"
      />
    </div>
    <div class="w-full p-2 md:py-4 lg:py-5 md:px-5 lg:px-6 2xl:px-8 flex flex-col relative z-[2] lg:flex-1">
      <slot
        name="top"
        :route-name="routeName"
      />
      <div class="flex-1 flex flex-col justify-center p-3">
        <slot
          name="aboveheading"
          :route-name="routeName"
        />
        <CollectionBusinessOnlineIndicator
          :visible="online"
          size="lg"
          :ui="{ wrapper: 'justify-start' }"
        >
          <NuxtLink
            v-motion
            :to="routeName"
            class="line-clamp-3 text-2xl md:text-2xl lg:text-4xl xl:text-6xl font-bold font-display !leading-[0.85] uppercase mb-3 heading text-transparent"
            :class="classes?.subheading"
            :visible="{ opacity: 1, scale: 1 }"
            :initial="{ opacity: 0, scale: 0.4 }"
            :delay="200"
          >
            <slot name="heading" />
          </NuxtLink>
        </CollectionBusinessOnlineIndicator>
        <div
          v-motion
          class="line-clamp-3"
          :visible="{ opacity: 1, scale: 1 }"
          :initial="{ opacity: 0, scale: 0.4 }"
          :delay="400"
        >
          <slot :route-name="routeName" />
        </div>
      </div>
      <div class="flex flex-wrap gap-3 md:gap-x-4 justify-end p-3">
        <slot
          name="buttons"
          :route-name="routeName"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="css">
.businesses, .businessesOverview{
  @apply bg-blue text-white;
}
.businesses .side, .businessesOverview .side{
    background: linear-gradient(341.86deg, #F26D97 51.5%, #009AFF 121.17%);
  }
.offers, .offersOverview{
  @apply bg-blue text-white;
}
.offers .side, .offersOverview .side{
  background: linear-gradient(341.86deg, #FFD129 51.5%, #009AFF 121.17%);
}
.events, .eventsOverview{
  @apply bg-pink text-white;
}
.events .side, .eventsOverview .side{
  background: linear-gradient(0deg, #F26D97 0.5%, #009AFF 121.17%);
}

.pages{
  @apply bg-pink text-white;
}
.pages .side{
  background: linear-gradient(120deg, #F26D97 0.5%, #009AFF 121.17%);
}

.news{
  @apply bg-pink text-white;
}
.news .heading{
  @apply text-white;
}
.news .side{
  background: linear-gradient(120deg, #F26D97 0.5%, #009AFF 121.17%);
}
</style>
